import { AuditItem } from '@cdab/scania/qpr/components/atoms'
import styled, { css } from 'styled-components'
//NOTE: TDS deleted orange colors, using hardcoded from SDDS
export const StyledAuditPointItem = styled(AuditItem)`
  &:hover {
    background-color: var(--tds-grey-100);
  }

  ${({ isMandatory, selected }) => {
    if (isMandatory && selected) {
      return css`
        background-color: #f9a38d;
        &:hover {
          background-color: #f98a67;
        }
      `
    }

    if (isMandatory) {
      return css`
        background-color: #fbe3df;

        &:hover {
          background-color: #f9cac0;
        }
      `
    }

    if (selected) {
      return css`
        background-color: var(--tds-grey-300);
      `
    }

    return css`
      background-color: var(--tds-grey-50);
    `
  }}
`
